<template>
  <div v-if="show" class="loading-overlay">
    <div class="loading-overlay-loader">
      <div class="loading-overlay-spinner">
        <div class="spinner-ring"></div>
        <div class="spinner-ring"></div>
        <div class="spinner-ring"></div>
        <div class="spinner-ring"></div>
      </div>
      <div class="loading-overlay-text">
        <h3>{{ title || 'Loading...' }}</h3>
        <p>{{ message || 'Please wait' }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import './LoadingOverlay.css';

export default {
  name: 'LoadingOverlay',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Loading...'
    },
    message: {
      type: String,
      default: 'Please wait'
    }
  }
};
</script>
